module.exports = __webpack_public_path__ + "static/media/Partner-LogosBluedoors.5363d0f6.png";